
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic13Off as ObiHydraulic13OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-13-off.js';
 
 
 

 
 export const ObiHydraulic13Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-13-off',
   elementClass: ObiHydraulic13OffElement,
   events: {
     
   }
  });
 
 